<h1 mat-dialog-title>בטל קמפיין?</h1>
<div mat-dialog-content>האם אתה בטוח שברצונך לבטל קמפיין ({{data.campaign.id}}) זה? </div>
<div mat-dialog-actions class="action">
  <button mat-stroked-button (click)="onNoClick(null)" cdkFocusInitial>חזור</button>
  <button mat-stroked-button (click)="onNoClick(data.campaign)"  class="second">אישור</button>
</div>

